import React, { Component } from 'react';
import moment from 'moment';

import './style.scss';
import { Page, PageHeader, Card, TextButton } from '../../common/ui';
import ModalChangeLog from '../../common/modal/modalChangeLog';
import Modal from '../../common/modal';
import Loading from '../../common/loading';
import { randomString } from '../../common/actions/randomString';
import { API_CHANGELOG, API_DELETE_CHANGELOG, MAINTENANCE } from '../../config';
import { controlRole } from '../../common/actions/controlRole';
import { isEmpty, withNavigate } from '../../utility';
import axiosInstance from '../../axiosInstance';

// tipo di alert dell'avviso sul sito, in base alla versione salvata
const MAINTENANCE_ALERTS = {
    '0.0.1': { key: 'Red', label: 'Alert rosso' },
    '0.0.2': { key: 'Green', label: 'Alert verde' },
    '0.0.3': { key: 'Yellow', label: 'Alert giallo' },
    '0.0.4': { key: 'Blue', label: 'Alert blu' },
};

class ChangeLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            loadingForRole: true,

            // titolo del prodotto
            typeChangeLog: '',

            // contiene la lista di tutti i changeLog
            getChangeLog: {},

            dateVersion: null,

            shortId: randomString(),

            // variabili per modali
            titleModal: '',
            contentModal: '',
            modalChangeLog: false,
            modal: false,

            hasClickNewChangeLog: false,
            hasClickEditChangeLog: false,
            hasClickNewVersionChangeLog: false,
            hasClickDeleteChangeLog: false,
            hasClickDeleteVersionChangeLog: false,

            // versione del prodotto selezionata dall'utente
            versionTemp: '',

            inMaintenance: false,

            // logs della versione del prodotto selezionata dall'utente
            logsIt: '',
            logsEn: '',
            logsEs: '',
            logsDe: '',
            logsFr: ''
        }
    }

    /**
     * Il mount e l'update sono uguali, poiche se navigo tra i link di react router, dopo aver
     * caricato questa pagina, esegue solo il mount, mentre se refresho la pagina carica l'update.
     * 
     * (Esempio: se vado una prima volta sulla pagina utenti, dopo il mount carica update.
     * Se dopo il caricamento, senza refreshare, navigo e vado ad altre parti, esempio player, e poi ritorno,
     * react carica solo il mount e nemmeno una volta update.)
     */
    componentDidMount() {
        // se l'utente non ha nessun permesso per visualizzare i changelog, viene rispedito alla home
        if (!isEmpty(this.props.role.changeLog)) {
            if (!controlRole(this.props.role.changeLog, "api/Changelog", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare le changelog!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getChangeLog();
                }
            }
        }
    }

    componentDidUpdate() {
        // se l'utente non ha nessun permesso per visualizzare i changelog, viene rispedito alla home
        if (!isEmpty(this.props.role.changeLog)) {
            if (!controlRole(this.props.role.changeLog, "api/Changelog", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare le changelog!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getChangeLog();
                }
            }
        }

        if (!localStorage.token) {
            this.props.handleNavigation(this.props.navigate, '/');
        }
    }

    onChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    getChangeLog = async () => {
        this.setState({
            isLoading: true,
            inMaintenance: false
        });
        try {
            let response = await axiosInstance.get(API_CHANGELOG);
            this.setState({
                getChangeLog: response.data,
                typeChangeLog: Object.keys(response.data)[0],
                isLoading: false
            });
            // eslint-disable-next-line
            Object.keys(response.data).map(el => {
                if (el === MAINTENANCE) this.setState({ inMaintenance: true })
            })
        } catch (result) {
            const { errorNotify } = this.props;
            this.setState({ isLoading: false });
            if (result && result.response && result.response.status) {
                switch (result.response) {
                    default: errorNotify(`Error ${result.response.status} su ${API_CHANGELOG} - GET`); break;
                }
            }
        }
    }

    toggleModal = () => {
        this.setState({
            modalChangeLog: false,
            modal: false,
            hasClickNewChangeLog: false,
            hasClickEditChangeLog: false,
            hasClickDeleteChangeLog: false,
            hasClickDeleteVersionChangeLog: false,
            hasClickNewVersionChangeLog: false,
            titleModal: '',
            contentModal: '',
            versionTemp: '',
            logsIt: '',
            logsEn: '',
            logsEs: '',
            logsDe: '',
            logsFr: '',
            dateVersion: null,
            shortId: randomString(),
        })
    }

    /**
     * Apre la modale per la creazione di un nuovo prodotto per changelog.
     */
    hasClickNewChangeLog = () => {
        this.setState({
            hasClickNewChangeLog: true,
            titleModal: 'Nuovo Prodotto',
        });
        setTimeout(() => {
            this.setState(prevState => ({ modalChangeLog: !prevState.modalChangeLog }));
        }, 100);
    }

    /**
     * Apre la modale per la creazione di una nuova versione per un prodotto di changelog.
     */
    hasClickNewVersionChangeLog = () => {
        this.setState({
            hasClickNewVersionChangeLog: true,
            titleModal: 'Aggiungi Versione a ' + this.state.typeChangeLog,
        });
        setTimeout(() => {
            this.setState(prevState => ({ modalChangeLog: !prevState.modalChangeLog }));
        }, 100);
    }

    /**
     * Apre la modale per la modifica di una nuova versione per un prodotto di changelog.
     * 
     * @param version
     * @param date
     * @param logs
     */
    hasClickEditChangeLog = (version, logs, date) => {
        this.setState({
            hasClickEditChangeLog: true,
            versionTemp: version,
            dateVersion: date,
            logsIt: logs[`it-IT`],
            logsEn: logs[`en-GB`],
            logsEs: logs[`es-SP`],
            logsDe: logs[`de-DE`],
            logsFr: logs[`fr-FR`],
            titleModal: 'Modifica Log alla versione ' + version,
        });
        setTimeout(() => {
            this.setState(prevState => ({ modalChangeLog: !prevState.modalChangeLog }));
        }, 100);
    }

    /**
     * Apre la modale per l'eliminazione di una versione da un prodotto.
     */
    hasClickDeleteVersionChangeLog = (version) => {
        this.setState({
            hasClickDeleteVersionChangeLog: true,
            versionTemp: version,
            titleModal: 'Elimina Versione da ' + this.state.typeChangeLog,
            contentModal: 'Sei sicuro di voler eliminare la versione ' + version + ' da ' + this.state.typeChangeLog + ' ?',
        });
        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 100);
    }

    /**
     * Apre la modale per l'eliminazione di un prodotto changelog.
     */
    hasClickDeleteChangeLog = (el) => {
        this.setState({
            hasClickDeleteChangeLog: true,
            typeChangeLog: el,
            titleModal: 'Elimina Prodotto dai ChangeLog',
            contentModal: 'Sei sicuro di voler eliminare il prodotto ' + el + ' e tutte le sue versioni associate?',
        });
        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 100);
    }

    /**
     * Crea un nuovo prodotto per le versioni.
     * 
     * @param {*} name è il nome del nuovo prodotto
     */
    newChangeLog = (name) => {
        this.setState({ isLoading: true });
        try {
            let params = {
                "productName": name,
                "version": "0.0.1",
                "createdAt": moment(),
                "logLanguage": {
                    "it-IT": "Primo commit",
                    "en-GB": "First commit",
                    "es-SP": "Primer compromiso",
                    "de-DE": "Erstes commit",
                    "fr-FR": "Premier commit",
                }
            };
            let that = this;
            axiosInstance.put(API_CHANGELOG, params)
                .then(function () {
                    that.getChangeLog();
                    that.props.successNotify('Prodotto aggiunto con successo!');
                    that.setState({ isLoading: false });
                });

        } catch (result) {
            this.setState({ isLoading: false });
            if (result && result.response && result.response.status) {
                this.props.errorNotify('Prodotto non aggiunto. Errore: ' + result.response.status);
            }
        }
    }

    /**
     * Modifica una versione per un prodotto già esistente.
     * 
     * @param {Object} data contiene productName, version, logs
     */
    editVersionLog = (data) => {
        this.setState({ isLoading: true });
        try {
            let that = this;
            axiosInstance.put(API_CHANGELOG, data)
                .then(function () {
                    that.getChangeLog();
                    that.props.successNotify('Versione aggiornata con successo!');
                    that.setState({ isLoading: false });
                });

        } catch (result) {
            this.setState({ isLoading: false });
            if (result && result.response && result.response.status) {
                this.props.errorNotify('Versione non aggiornata. Errore ' + result.response.status);
            }
        }
    }

    /**
     * Modifica una versione per un warning già esistente.
     * Cancello la versione che c'è e inserisco la nuova versione.
     * 
     * @param {Object} data
     */
    editWarning = async (data) => {
        this.setState({ isLoading: true });
        try {
            let that = this;
            await axiosInstance.delete(`${API_CHANGELOG}?productName=${this.state.typeChangeLog}&version=${data.oldVersion}`);
            await axiosInstance.put(API_CHANGELOG, data)
                .then(function () {
                    that.getChangeLog();
                    that.props.successNotify('Warning aggiornato con successo!');
                    that.setState({ isLoading: false });
                });


        } catch (result) {
            this.setState({ isLoading: false });
            if (result && result.response && result.response.status) {
                this.props.errorNotify('Versione non aggiornata. Errore ' + result.response.status);
            }
        }
    }

    /**
     * Elimina una versione da un prodotto.
     * 
     */
    deleteVersionChangeLog = () => {
        this.setState({ isLoading: true });
        try {

            let that = this;
            axiosInstance.delete(`${API_CHANGELOG}?productName=${this.state.typeChangeLog}&version=${this.state.versionTemp}`)
                .then(function () {
                    that.getChangeLog();
                    that.props.successNotify('Versione rimossa con successo!');
                    that.setState({ isLoading: false });
                });

        } catch (result) {
            this.setState({ isLoading: false });
            if (result && result.response && result.response.status) {
                this.props.errorNotify('Errore ' + result.response.status + ' su /api/Changelog - DELETE');
            }
        }
    }

    /**
     * Elimina prodotto con tutte le relative versioni.
     * 
     */
    deleteChangeLog = () => {
        this.setState({ isLoading: true });
        try {

            let that = this;
            axiosInstance.delete(`${API_DELETE_CHANGELOG}?productName=${this.state.typeChangeLog}`)
                .then(function () {
                    that.getChangeLog();
                    that.props.successNotify('Prodotto rimosso con successo!');
                    that.setState({ isLoading: false });
                });

        } catch (result) {
            this.setState({ isLoading: false });
            if (result && result.response && result.response.status) {
                this.props.errorNotify('Errore ' + result.response.status + ' su /api/Changelog/DeleteChangelog');
            }
        }
    }

    render() {
        const { role } = this.props;
        const { getChangeLog, typeChangeLog } = this.state;

        const canEdit = controlRole(role.changeLog, "api/Changelog", "PUT");
        const canDeleteVersion = controlRole(role.changeLog, "api/Changelog", "DELETE");
        const canDeleteProduct = controlRole(role.changeLog, "api/Changelog/DeleteChangelog", "DELETE");

        const products = isEmpty(getChangeLog) ? [] : Object.keys(getChangeLog);
        const isMaintenance = typeChangeLog === MAINTENANCE;
        const versions = (getChangeLog && getChangeLog[typeChangeLog]) ? Object.keys(getChangeLog[typeChangeLog]).map(key => getChangeLog[typeChangeLog][key]) : [];
        const productLabel = (name) => name === MAINTENANCE ? 'Avviso sito' : name;

        return (
            <Page>
                <PageHeader
                    title="News / Change Log"
                    subtitle={`${products.length} prodotti`}
                    actions={
                        canEdit &&
                        <>
                            {
                                // se risulta già un avviso di manutenzione sul sito, non generarne un altro (e sovrascriverlo)
                                !this.state.inMaintenance &&
                                <button type="button" className="btn btn-sm btn-outline-warning" onClick={() => { this.newChangeLog(MAINTENANCE) }}>
                                    <i className="fas fa-exclamation-triangle" aria-hidden="true" /> Avviso sul sito
                                </button>
                            }
                            <button type="button" className="btn btn-sm btn-success" onClick={this.hasClickNewChangeLog}>
                                <i className="fas fa-plus" aria-hidden="true" /> Nuovo prodotto
                            </button>
                        </>
                    }
                />

                {
                    (this.state.loadingForRole || this.state.isLoading) ? <Loading /> :
                        products.length === 0 ?
                            <Card><div className="uiEmpty">Nessun prodotto</div></Card>
                            :
                            <>
                                <div className="clTabs" role="tablist" aria-label="Prodotti">
                                    {
                                        products.map(el => (
                                            <button
                                                key={el}
                                                type="button"
                                                role="tab"
                                                name="typeChangeLog"
                                                value={el}
                                                aria-selected={typeChangeLog === el}
                                                className={`clTab${typeChangeLog === el ? ' isActive' : ''}${el === MAINTENANCE ? ' isWarning' : ''}`}
                                                onClick={this.onChange}
                                            >
                                                {el === MAINTENANCE && <i className="fas fa-exclamation-triangle" aria-hidden="true" />}
                                                {productLabel(el)}
                                            </button>
                                        ))
                                    }
                                </div>

                                <Card
                                    title={productLabel(typeChangeLog)}
                                    subtitle={isMaintenance ? 'Avviso mostrato sul sito' : `${versions.length} versioni`}
                                    actions={
                                        <>
                                            {
                                                canEdit && !isMaintenance &&
                                                <button type="button" className="btn btn-sm btn-success" onClick={this.hasClickNewVersionChangeLog}>
                                                    <i className="fas fa-plus" aria-hidden="true" /> Aggiungi versione
                                                </button>
                                            }
                                            {
                                                canDeleteProduct &&
                                                <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => { this.hasClickDeleteChangeLog(typeChangeLog) }}>
                                                    <i className="far fa-trash-alt" aria-hidden="true" /> {isMaintenance ? 'Elimina avviso' : 'Elimina prodotto'}
                                                </button>
                                            }
                                        </>
                                    }
                                >
                                    {
                                        versions.length === 0 ?
                                            <div className="uiEmpty">Nessuna versione</div>
                                            :
                                            versions.map(version => (
                                                <article className="clVersion" key={version.version}>
                                                    <header className="clVersionHeader">
                                                        <div className="clVersionTitle">
                                                            {
                                                                isMaintenance ?
                                                                    <span className={`clAlert clAlert${MAINTENANCE_ALERTS[version.version] ? MAINTENANCE_ALERTS[version.version].key : ''}`}>
                                                                        {MAINTENANCE_ALERTS[version.version] ? MAINTENANCE_ALERTS[version.version].label : version.version}
                                                                    </span>
                                                                    :
                                                                    <>
                                                                        <span className="clVersionNumber">v {version.version}</span>
                                                                        <span className="uiMuted">{moment(version.createdAt).format('DD/MM/YYYY')}</span>
                                                                    </>
                                                            }
                                                        </div>

                                                        <div className="uiActions">
                                                            {
                                                                canEdit &&
                                                                <TextButton icon="far fa-edit" onClick={() => { this.hasClickEditChangeLog(version.version, version.languageLogs, version.createdAt) }}>
                                                                    Modifica
                                                                </TextButton>
                                                            }
                                                            {
                                                                canDeleteVersion && !isMaintenance &&
                                                                <TextButton icon="far fa-trash-alt" variant="danger" onClick={() => { this.hasClickDeleteVersionChangeLog(version.version) }}>
                                                                    Elimina
                                                                </TextButton>
                                                            }
                                                        </div>
                                                    </header>

                                                    <div className="clLangs">
                                                        {
                                                            Object.keys(version.languageLogs || {}).map(lang => (
                                                                <div className="clLang" key={lang}>
                                                                    <h5>{lang.toUpperCase()}</h5>
                                                                    <ul>
                                                                        {
                                                                            String(version.languageLogs[lang] || '').split("\n").filter(line => line.trim() !== '').map((line, key) => (
                                                                                <li key={key}>{line}</li>
                                                                            ))
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </article>
                                            ))
                                    }
                                </Card>
                            </>
                }

                {
                    (this.state.hasClickNewChangeLog || this.state.hasClickEditChangeLog || this.state.hasClickNewVersionChangeLog) &&
                    <ModalChangeLog
                        titleModal={this.state.titleModal}
                        type={
                            this.state.hasClickNewChangeLog ? 'newChangeLog' :
                                this.state.hasClickNewVersionChangeLog ? 'newVersionLog' :
                                    this.state.hasClickEditChangeLog ? 'editVersionLog' : ''
                        }
                        toggle={this.toggleModal}
                        stateModal={this.state.modalChangeLog}

                        version={this.state.versionTemp}
                        dateVersion={this.state.dateVersion}
                        logsIt={this.state.logsIt}
                        logsEn={this.state.logsEn}
                        logsEs={this.state.logsEs}
                        logsDe={this.state.logsDe}
                        logsFr={this.state.logsFr}
                        typeChangeLog={this.state.typeChangeLog}

                        newChangeLog={this.newChangeLog}
                        editVersionLog={this.editVersionLog}
                        editWarning={this.editWarning}

                        key={this.state.shortId}
                        errorNotify={this.props.errorNotify}
                    />
                }

                {
                    (this.state.hasClickDeleteChangeLog || this.state.hasClickDeleteVersionChangeLog) &&
                    <Modal
                        click={
                            () => {
                                if (this.state.hasClickDeleteVersionChangeLog) this.deleteVersionChangeLog();
                                if (this.state.hasClickDeleteChangeLog) this.deleteChangeLog();
                                this.toggleModal();
                            }
                        }
                        titleModal={this.state.titleModal}
                        contentModal={this.state.contentModal}
                        toggle={this.toggleModal}
                        stateModal={this.state.modal}
                    />
                }
            </Page>
        )
    }
}

export default withNavigate(ChangeLog);